import type { IntentClassificationData, NavContentIntent } from './types';

export const isNavContentIntent = (intent: IntentClassificationData): intent is NavContentIntent =>
	intent.__typename === 'KnowledgeDiscoveryNavContentIntent';
